import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/pages/home/Home'
import Faq from '@/components/pages/FAQ'
import Activation from '@/components/pages/Activation'
import Contact from '@/components/pages/Contact'

import Login from '@/components/client/Login'
import Client from '@/components/client/Client'
import Claim from '@/components/client/Claim'

import NotFound from '@/components/pages/NotFound'

import { isLoggedIn } from '@/auth'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes: [
        { path: '/', component: Home },
        { path: '/faq', component: Faq },
        { path: '/login', component: Login, meta: { nav: 'account' } },
        { path: '/activation', component: Activation },
        {
            path: '/client',
            component: Client,
            meta: {
                nav: 'account',
                requiresAuth: true
            }
        },
        {
            path: '/claim',
            component: Claim,
            meta: {
                nav: 'account',
                requiresAuth: true
            }
        },
        { path: '/contact', component: Contact },
        { path: '/404', component: NotFound },
        { path: '/*', redirect: '/404' }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn()) {
        window.sessionStorage.removeItem('access_token')
        next('/login?session=expired')
    }
    next()
})

export default router